import type { RouteObject } from "react-router-dom";
import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
  redirect,
  useRoutes,
} from "react-router-dom";
import EnterView from "../components/EnterView";
import { useAppStore } from "../stores/RootStore";
import { RootProvider } from "../contexts/RootContext";
import ForgetView from "../components/EnterView/forgetView";
import ResetPasswordView from "../components/EnterView/resetPasswordView";
import ProducerItem from "../pages/directories/producers/ProducerItem";

import { Staff } from "../pages/staff/Staff";
import StaffEdit from "../pages/staff/StaffEdit";
import AddStaff from "../pages/staff/AddStaff";

import { Equipments } from "../pages/equipment/Equipments";
import { Producers } from "../pages/directories/producers/Producers";
import RoleRequire from "../helpers/auth/RoleRequire";
import { Positions } from "../pages/directories/positions/Positions";
import PostItem from "../pages/directories/positions/postItem/PostItem";
import { Devices } from "../pages/devices/Devices";
import SidebarLayout from "../components/Layout/sidebar";
import RootLayout from "../components/Layout/root";
import BaseLayout from "../components/Layout/base";
import DeviceItem from "../pages/devices/DeviceItem";
import AddDeviceForm from "../pages/devices/devicesComponents/AddDeviceForm";
import { EquipmentTypes } from "../pages/directories/equipmentTypes/Types";
import EquipmentTypeItem from "../pages/directories/equipmentTypes/TypeItem";

import { Shifts } from "../pages/directories/shifts/Shifts";
import ShiftItem from "../pages/directories/shifts/shiftItem/ShiftItem";
import AddShift from "../pages/directories/shifts/AddShift";

import EquipmentAdd from "../pages/equipment/EquipmentAdd";
import EquipmentEdit from "../pages/equipment/EquipmentEdit";

import DivisionItem from "../pages/divisions/divisionItem/DivisionItem";
import AddType from "../pages/directories/equipmentTypes/AddType";
import AddPosition from "../pages/directories/positions/postItem/AddPosition";
import AddDivision from "../pages/divisions/AddDivision";
import AddProducer from "../pages/directories/producers/AddProducer";

import { Monitoring } from "../pages/monitoring/Monitoring";
import Tracking from "../pages/managment/tracking/Tracking";
import AddMaintenance from "../pages/managment/maintenance/ServiceTable/AddService";
import { Maintenances } from "../pages/managment/maintenance/Maintenances";
import Reports from "../pages/reports/Reports";
import { Users } from "../pages/settings/users/Users";
// import Settings from "../pages/settings/settings/Settings";
import { Settings } from "../pages/settings/Settings";

import { Apps } from "../pages/settings/apps/Apps";
import { Logs } from "../pages/settings/logs/Logs";

import Account from "../pages/account/account/Account";
import { Organizations } from "../pages/account/organizations/Organizations";
import AddOrganization from "../pages/account/organizations/AddOrganization";
import OrganizationItem from "../pages/account/organizations/organizationItem/OrganizationItem";
import UploadPage from "../pages/upload/upload";
import OazisUploadPage from "../pages/upload/oazis";
import { AdminDevices } from "../pages/admin/devices/Devices";
import AddAdminDevice from "../pages/admin/devices/AddAdminDevice";
import AdminDeviceItem from "../pages/admin/devices/deviceItem/AdminDeviceItem";
import { Sensors } from "../pages/admin/sensors/Sensors";
import AddSensor from "../pages/admin/sensors/AddSensor";
import SensorItem from "../pages/admin/sensors/sensorItem/SensorItem";
import AddModel from "../pages/admin/models/AddModel";
import ModelItem from "../pages/admin/models/modelItem/ModelItem";
import { Triggers } from "../pages/settings/triggers/Triggers";
import LicenseAuthSetter from "../pages/settings/settings/LicenseAuthSetter";
import { publicConfig } from "@/config/publicConfig";
import { Directories } from "../pages/directories/Directories";
import OrganizationSettings from "../pages/settings/settings/Settings";
import { useTranslation } from "react-i18next";
import UsersGrid from "../pages/settings/users/UsersGrid";
import TriggersGrid from "../pages/settings/triggers/TriggersGrid";
import HomePage from "../pages/home/HomePage";

import AddScreen from "../pages/monitoring/Screen/AddScreen";
import MonitorContext from "../pages/monitoring/MonitorContext";
import { Divisions } from "../pages/divisions/Divisions";
import { Managment } from "../pages/managment/Managment";
import { Admin } from "@/pages/admin/Admin";
import { Models } from "@/pages/admin/models/Models";
import DowntimeItem from "@/pages/admin/downtimes/downtimeItem/DowntimeItem";
import AddDowntime from "@/pages/admin/downtimes/AddDowntime";
import { Downtimes } from "@/pages/admin/downtimes/Downtimes";

export default function Routes() {
  const { t } = useTranslation();
  const store = useAppStore();
  let public_routes: RouteObject[] = [
    { path: "/", element: <EnterView /> },
    { path: "/forget", element: <ForgetView /> },
    { path: "/reset-password/:hash", element: <ResetPasswordView /> },
    { path: "*", element: <p>Такой страницы не существует</p> },
  ];

  let protected_routes: RouteObject[] = [
    {
      path: "/",
      element: (
        <RootProvider>
          <RootLayout />
        </RootProvider>
      ),
      children: [
        {
          index: true,
          element: <HomePage />,
        },
        {
          path: "/monitoring",
          element: <Monitoring />,
          children: [
            { path: "new", element: <AddScreen /> },
            { path: ":id", element: <MonitorContext /> },
          ],
        },
        {
          path: "/managment",
          element: <Managment />,
          children: [
            {
              path: "maintenance",
              element: <Maintenances />,
              children: [
                { path: "", element: <Maintenances /> },
                { path: "new", element: <AddMaintenance /> },
              ],
            },
            { path: "tracking", element: <Tracking /> },
          ],
        },
        {
          path: "/analytics",
          element: <Reports />,
        },
        {
          path: "data",
          element: <BaseLayout />,
          children: [
            {
              path: "equipment",
              element: (
                <RoleRequire role="editor" isRoute>
                  <Equipments />
                </RoleRequire>
              ),
              children: [
                { path: "new", element: <EquipmentAdd /> },
                { path: ":id", element: <EquipmentEdit /> },
              ],
            },
            {
              path: "staff",
              element: (
                <RoleRequire role="editor" isRoute>
                  <Staff />
                </RoleRequire>
              ),
              children: [
                { path: "new", element: <AddStaff /> },
                {
                  path: ":id",
                  element: <StaffEdit />,
                },
              ],
            },
            {
              path: "devices",
              element: (
                <RoleRequire role="maintainer" isRoute>
                  <Devices />
                </RoleRequire>
              ),
              children: [
                { path: "new", element: <AddDeviceForm /> },
                { path: ":id", element: <DeviceItem /> },
              ],
            },
            {
              path: "directories",
              element: (
                <RoleRequire role="maintainer" isRoute>
                  <Directories />
                </RoleRequire>
              ),
            },
            {
              path: "manufactures",
              element: (
                <RoleRequire role="maintainer" isRoute>
                  <Producers />
                </RoleRequire>
              ),
              children: [
                { path: "new", element: <AddProducer /> },
                { path: ":id", element: <ProducerItem /> },
              ],
            },
            {
              path: "equipment_types",
              element: (
                <RoleRequire role="maintainer" isRoute>
                  <EquipmentTypes />
                </RoleRequire>
              ),
              children: [
                { path: "new", element: <AddType /> },
                { path: ":id", element: <EquipmentTypeItem /> },
              ],
            },
            {
              path: "divisions",
              element: (
                <RoleRequire role="maintainer" isRoute>
                  <Divisions />
                </RoleRequire>
              ),
              children: [
                { path: "new", element: <AddDivision /> },
                { path: ":id", element: <DivisionItem /> },
              ],
            },
            {
              path: "positions",
              element: (
                <RoleRequire role="maintainer" isRoute>
                  <Positions />
                </RoleRequire>
              ),
              children: [
                { path: "new", element: <AddPosition /> },
                {
                  path: ":id",
                  element: (
                    <RoleRequire role="maintainer" isRoute>
                      <PostItem />
                    </RoleRequire>
                  ),
                },
              ],
            },
            {
              path: "shifts",
              element: (
                <RoleRequire role="maintainer" isRoute>
                  <Shifts />
                </RoleRequire>
              ),
              children: [
                { path: "new", element: <AddShift /> },
                { path: ":id", element: <ShiftItem /> },
              ],
            },
          ],
        },
        {
          path: "settings",
          element: <BaseLayout />,
          children: [
            {
              path: "",
              element: (
                <RoleRequire role="maintainer" isRoute>
                  <Settings />
                </RoleRequire>
              ),
              children: [
                {
                  path: "",
                  element: <OrganizationSettings />,
                },
                {
                  path: "apps",
                  element: <Apps />,
                },
                {
                  path: "logs",
                  element: <Logs />,
                },
                {
                  path: "participants",
                  element: <Users />,
                  children: [{ path: "", element: <UsersGrid /> }],
                },
                {
                  path: "global_triggers",
                  element: <Triggers />,
                  children: [{ path: "", element: <TriggersGrid /> }],
                },
              ],
            },
          ],
        },
        {
          path: "account",
          element: <Account />,
        },
        {
          path: "organizations",
          element: (
            <RoleRequire role="maintainer" isRoute>
              <Organizations />
            </RoleRequire>
          ),
          children: [
            { path: "new", element: <AddOrganization /> },
            { path: ":id", element: <OrganizationItem /> },
          ],
        },
        {
          path: "upload",
          element: <BaseLayout />,
          children: [
            {
              path: "",
              element: <UploadPage />,
            },
            {
              path: "log",
              element: <OazisUploadPage />,
            },
          ],
        },
        {
          path: "admin",
          element: (
            <RoleRequire role="admin" isRoute>
              <Admin />
            </RoleRequire>
          ),
          children: [
            {
              path: "devices",
              element: <AdminDevices />,
              children: [
                {
                  path: "new",
                  element: <AddAdminDevice />,
                },
                {
                  path: ":id",
                  element: <AdminDeviceItem />,
                },
              ],
            },
            {
              path: "models",
              element: <Models />,
              children: [
                { path: "new", element: <AddModel /> },
                { path: ":id", element: <ModelItem /> },
              ],
            },
            {
              path: "sensors",
              element: <Sensors />,
              children: [
                {
                  path: "new",
                  element: <AddSensor />,
                },
                {
                  path: ":id",
                  element: <SensorItem />,
                },
              ],
            },
            {
              path: "downtimes",
              element: <Downtimes />,
              children: [
                {
                  path: "new",
                  element: <AddDowntime />,
                },
                {
                  path: ":id",
                  element: <DowntimeItem />,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: "/license",
      element: publicConfig.licensingEnabled ? <LicenseAuthSetter /> : <Navigate to="/settings" replace />,
    },
    { path: "*", element: <p>Такой страницы не существует</p> },
  ];

  let routes: RouteObject[] = store.currentUser
    ? protected_routes
    : public_routes;

  let element = useRoutes(routes);

  return element;
}
